<div class="library-filter">
  <div class="flex flex-row gap-1">
    <div class="flex-auto max-w-full">
      <app-search-bar [value]="filterValues.searchValue" (update)="searchUpdated($event)" />
    </div>
    <button
      mat-icon-button
      class="input-control--appearance-fill"
      [ngClass]="{ 'md:!hidden': isSplitScreen }"
      aria-label="Toggle filters"
      (click)="showFilters = !showFilters"
    >
      <mat-icon
        matBadge="+"
        matBadgeDescription="Filters applied"
        matBadgeOverlap="true"
        matBadgeSize="small"
        [matBadgeHidden]="!filterValues.hasFilters()"
        aria-hidden="false"
        >filter_list</mat-icon
      >
    </button>
  </div>
</div>
<div class="library-filters" [class.expand]="showFilters" [class.isSplitScreen]="isSplitScreen">
  <div class="notice flex justify-between">
    <h3 class="mat-subtitle-2" i18n>Filters</h3>
    @if (filterValues.hasFilters()) {
      <a href="#" (click)="!!clearFilterValues()" i18n>Clear all</a>
    }
  </div>
  <div
    class="flex flex-col gap-2"
    [ngClass]="{ 'md:flex-col': isSplitScreen, 'md:flex-row': !isSplitScreen }"
  >
    @if (unitTypeOptions.length > 0) {
      <div
        class="library-filter"
        [ngClass]="{ 'md:w-full': isSplitScreen, 'md:w-1/4': !isSplitScreen }"
      >
        <app-select-menu
          id="unitTypeSelectMenu"
          [options]="unitTypeOptions"
          i18n-placeholderText
          placeholderText="Type"
          [value]="filterValues.unitTypeValue"
          (update)="filterUpdated($event, 'unitType')"
          [valueProp]="'name'"
          [viewValueProp]="'name'"
          [multiple]="true"
        />
      </div>
    }
    @if (disciplineOptions.length > 0) {
      <div
        class="library-filter"
        [ngClass]="{ 'md:w-full': isSplitScreen, 'md:w-1/4': !isSplitScreen }"
      >
        <app-select-menu
          id="disciplineSelectMenu"
          [options]="disciplineOptions"
          i18n-placeholderText
          placeholderText="Discipline"
          [value]="filterValues.disciplineValue"
          (update)="filterUpdated($event, 'discipline')"
          [valueProp]="'id'"
          [viewValueProp]="'name'"
          [multiple]="true"
        />
      </div>
    }
    @if (gradeLevelOptions.length > 0 && showAdvancedFilteringOptions) {
      <div
        class="library-filter"
        [ngClass]="{ 'md:w-full': isSplitScreen, 'md:w-1/4': !isSplitScreen }"
      >
        <app-select-menu
          id="gradeLevelSelectMenu"
          [options]="gradeLevelOptions"
          i18n-placeholderText
          placeholderText="Grade Level"
          [value]="filterValues.gradeLevelValue"
          (update)="filterUpdated($event, 'gradeLevel')"
          valueProp="grade"
          viewValueProp="grade"
          [multiple]="true"
        />
      </div>
    }
    @if (standardOptions.length > 0) {
      <div
        class="library-filter"
        [ngClass]="{ 'md:w-full': isSplitScreen, 'md:w-1/4': !isSplitScreen }"
      >
        <standards-select-menu
          id="standardSelectMenu"
          [options]="standardOptions"
          [possibleLabels]="possibleStandardLabels"
          i18n-placeholderText
          placeholderText="Standards Addressed"
          [value]="filterValues.standardValue"
          (update)="filterUpdated($event, 'standard')"
          [valueProp]="'id'"
          [viewValueProp]="'name'"
          [multiple]="true"
        />
      </div>
    }
    @if (featureOptions.length > 0) {
      <div
        class="library-filter"
        [ngClass]="{ 'md:w-full': isSplitScreen, 'md:w-1/4': !isSplitScreen }"
      >
        <app-select-menu
          [options]="featureOptions"
          i18n-placeholderText
          placeholderText="Features"
          [value]="filterValues.featureValue"
          (update)="filterUpdated($event, 'feature')"
          valueProp="name"
          viewValueProp="name"
          [multiple]="true"
        />
      </div>
    }
  </div>
</div>
